var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgramingData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.16667H2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 5.83333H7.50033C7.04033 5.83333 6.66699 5.46 6.66699 5V3.33333C6.66699 2.87333 7.04033 2.5 7.50033 2.5H16.667C17.127 2.5 17.5003 2.87333 17.5003 3.33333V5C17.5003 5.46 17.127 5.83333 16.667 5.83333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.0007H2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 11.6673H7.50033C7.04033 11.6673 6.66699 11.294 6.66699 10.834V9.16732C6.66699 8.70732 7.04033 8.33398 7.50033 8.33398H16.667C17.127 8.33398 17.5003 8.70732 17.5003 9.16732V10.834C17.5003 11.294 17.127 11.6673 16.667 11.6673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 17.4993H7.50033C7.04033 17.4993 6.66699 17.126 6.66699 16.666V14.9993C6.66699 14.5393 7.04033 14.166 7.50033 14.166H16.667C17.127 14.166 17.5003 14.5393 17.5003 14.9993V16.666C17.5003 17.126 17.127 17.4993 16.667 17.4993Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15.8333H3.33333C2.87333 15.8333 2.5 15.46 2.5 15V2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramingData);
export default __webpack_public_path__ + "static/media/ProgramingData.9098aaef6b480d686dce45394831dee0.svg";
export { ForwardRef as ReactComponent };